import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { PositionDescriptionType } from './position-description-type';
import { PositionDescriptionTypeService } from './position-description-type.service';

const service = new PositionDescriptionTypeService();

export interface PositionDescriptionTypeState {
   positionDescriptionTypes: Array<PositionDescriptionType>;
}

const PositionDescriptionTypeStore: Module<PositionDescriptionTypeState, StoreState> = {
   namespaced: true,
   state: {
      positionDescriptionTypes: [],
   },
   getters: {
      positionDescriptionTypes: (state) => state.positionDescriptionTypes,
   },
   mutations: {
      SET_POSITION_DESCRIPTION_TYPES(state, positionDescriptionTypes: Array<PositionDescriptionType>) {
         state.positionDescriptionTypes = positionDescriptionTypes;
      },
   },
   actions: {
      async getPositionDescriptionTypes(context, query: LocationQuery) {
         const response = await service.getPositionDescriptionTypes({ ...query, per_page: '9999', page: '1' });
         context.commit('SET_POSITION_DESCRIPTION_TYPES', response.data);
         return response;
      },
   },
};

export default PositionDescriptionTypeStore;
